<template>
  <v-dialog
    v-model="showTypes"
    scrollable
    width="800"
    @keydown.esc="showTypes = false"
  >
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-btn text absolute right icon @click="showTypes = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-flex sm11>
            <h3 class="headline mb-0">{{ $t('TEMPLATE_SEARCH_HEAD') }}</h3>
          </v-flex>
          <v-flex sm12>
            {{ $t('TEMPLATE_SEARCH_LANG') }}: <!-- TODO: show current language -->
          </v-flex>
          <v-flex sm12>
            <v-text-field
              v-model="filter"
              label="Template title filter"
              append-icon="mdi-magnify"
              @click:append="onFilter()"
            >
            </v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-alert
              v-if="mailingTemplatesCache.length"
              :value="templatesFoundCache > 0" 
              :color="templatesFoundCache > 50 ? 'warning' : 'info'"
              :icon="templatesFoundCache > 50 ? 'priority_high' : 'info'"
              outlined
            >
              <span v-if="templatesFoundCache == 1">{{ $t('TEMPLATE_SEARCH_RESULTS_ONE') }}</span>
              <span v-else-if="templatesFoundCache > 50">{{ $t('TEMPLATE_SEARCH_RESULTS_TOOMANY_2', [templatesFoundCache, 50]) }}</span>
              <span v-else>{{ $t('TEMPLATE_SEARCH_RESULTS_MANY', [templatesFoundCache]) }}</span>
            </v-alert>
            <div v-if="isBusy" class="text-xs-center">
              <v-progress-linear
                indeterminate
                color="primary"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex sm12>
            <v-list
              v-if="mailingTemplatesCache.length"
              three-line
            >
              <v-list-item
                v-for="(template, index) in mailingTemplatesCache"
                :key="index"
                @click="$emit('select', template)"
              >
                <v-list-item-action>
                  <v-icon
                    v-if="template.status"
                    :color="(template.status === 'online') ? 'success' : 'error'"
                  >{{ (template.status === 'online') ? 'mdi-check-network-outline' : 'mdi-close-network-outline' }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ template.path }}<br />
                  <strong>{{ template.title }}</strong>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters} from 'vuex'
import Search from '../services/Search'

export default {
  name: 'MailingViewTemplateDlg',
  props: ['visible', 'lang_id'],
  data() {
    return {
      filter: '',
      showTypesCache: null,
      mailingTemplatesCache: [],
      templatesFoundCache: 0,
    }
  },
  computed: {
    ...mapGetters(['isBusy', 'mailingTemplates', 'templatesFound']),
    showTypes: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('cancel')
        }
      }
    },
  },
  watch: {
    showTypes(val) {
      if (val) {
        this.filter = ''
        this.onFilter()
      }
    },
    mailingTemplates(val) {
      this.mailingTemplatesCache = val
    },
    templatesFound(val) {
      this.templatesFoundCache = val
    },
  },
  methods: {
    onFilter() {
      if (this.showTypes !== this.showTypesCache) {
        this.mailingTemplatesCache = []
        this.templatesFoundCache = 0
      }
      new Search(this.$api).search_pages({search_string: this.filter, allowed_types: this.showTypes, lang_id: this.lang_id})
      this.showTypesCache = this.showTypes
    },
  },
}
</script>

<style>

</style>
